module.exports = __webpack_public_path__ + "video/SERF25-0800-Artificial_Intelligence.9bc66725.vtt";